import { all_routes } from "../../Router/all_routes";
import { translate } from "../../utils/useTranslation.js";

const route = all_routes;

export const getSidebarData = () => [
  {
    label: translate("Main"),
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: translate("Dashboard"),
        link: "/index",
        icon: "layout-grid",
        submenu: true,
        showSubRoute: false,

        // submenuItems: [
        //   { label: translate("Admin Dashboard"), link: "/index" },
        //   { label: "Admin Dashboard 2", link: "/admin-dashboard" },
        //   { label: translate("Sales Dashboard"), link: "/sales-dashboard" },
        // ],
      },
      // {
      //   label: "Super Admin",
      //   icon: "user-edit",
      //   submenu: true,
      //   showSubRoute: false,

      //   submenuItems: [
      //     { label: translate("Dashboard"), link: "/dashboard" },
      //     { label: translate("Companies"), link: "/companies" },
      //     { label: translate("Subscriptions"), link: "/subscription" },
      //     { label: translate("Packages"), link: "/packages" },
      //     { label: translate("Domain"), link: "/domain" },
      //     { label: translate("Purchase Transaction"), link: route.purchasetransaction },
      //   ],
      // },
      // {
      //   label: translate("Application"),
      //   icon: "brand-apple-arcade",
      //   submenu: true,
      //   showSubRoute: false,
      //   submenuItems: [
      //     { label: translate("Chat"), link: "/chat", showSubRoute: false },
      //     {
      //       label: "Call",
      //       submenu: true,
      //       submenuItems: [
      //         { label: translate("Video Call"), link: "/video-call" },
      //         { label: translate("Audio Call"), link: "/audio-call" },
      //         { label: translate("Call History"), link: "/call-history" },
      //       ],
      //     },
      //     { label: translate("Calendar"), link: "/calendar", showSubRoute: false },
      //     { label: translate("Contact"), link: "/contacts", showSubRoute: false },
      //     { label: translate("Email"), link: "/email", showSubRoute: false },
      //     { label: translate("To Do"), link: "/todo", showSubRoute: false },
      //     { label: translate("Notes"), link: "/notes", showSubRoute: false },
      //     { label: translate("File Manager"), link: "/file-manager", showSubRoute: false },
      //     { label: translate("Projects"), link: "/projects", showSubRoute: false },
      //     {
      //       label: translate("Ecommerce"),
      //       submenu: true,
      //       submenuItems: [
      //         { label: translate("Products"), link: "/products" },
      //         { label: translate("Orders"), link: "/orders" },
      //         { label: translate("Customers"), link: "/customers" },
      //         { label: translate("Cart"), link: "/cart" },
      //         { label: translate("Checkout"), link: "/checkout" },
      //         { label: translate("Wishlist"), link: "/wishlist" },
      //         { label: translate("Reviews"), link: "/reviews" },
      //       ],
      //     },
      //     { label: "Social Feed", link: "/social-feed", showSubRoute: false },
      //     { label: "Search List", link: "/search-list", showSubRoute: false },
      //   ],
      // },
      // {
      //   label: "Layouts",
      //   icon: "layout-sidebar-right-collapse",
      //   submenu: true,
      //   showSubRoute: false,
      //   submenuItems: [
      //     { label: "Horizontal", link: route.Horizontal, showSubRoute: false },
      //     { label: "Detached", link: route.Detached, showSubRoute: false },
      //     // { label: "Modern", link: route.Modern, showSubRoute: false },
      //     { label: "Two Column", link: route.TwoColumn, showSubRoute: false },
      //     { label: "Hovered", link: route.Hovered, showSubRoute: false },
      //     { label: "Boxed", link: route.Boxed, showSubRoute: false },
      //     { label: "RTL", link: route.RTL, showSubRoute: false },
      //     { label: "Dark", link: route.Dark, showSubRoute: false },
      //   ],
      // },
    ],
  },
  {
    label: translate("Inventory"),
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    submenuItems: [
      {
        label: translate("Products"),
        link: "/product-list",
        icon: "box",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Create Product"),
        link: "/add-product",
        icon: "table-plus",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Expired Products"),
        link: "/expired-products",
        icon: "progress-alert",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Low Stocks"),
        link: "/low-stocks",
        icon: "trending-up-2",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Category"),
        link: "/category-list",
        icon: "list-details",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Sub Category"),
        link: "/sub-categories",
        icon: "carousel-vertical",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Brands"),
        link: "/brand-list",
        icon: "triangles",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Units"),
        link: "/units",
        icon: "brand-unity",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Variant Attributes"),
        link: "/variant-attributes",
        icon: "checklist",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Warranties"),
        link: "/warranty",
        icon: "certificate",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Print Barcode"),
        link: "/barcode",
        icon: "barcode",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Order Report"),
        link: "/transaction-history",
        icon: "certificate",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Subscription"),
        link: "/pos-subscription",
        icon: "checklist",
        showSubRoute: false,
        submenu: false,
      },
      // {
      //  label: translate("Print QR Code"),
      //   link: "/qrcode",
      //   icon: "qrcode",
      //   showSubRoute: false,
      //   submenu: false,
      // },
    ],
  },
  {
    label: translate("Stock"),
    submenuOpen: true,
    submenuHdr: "Stock",
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: translate("Manage Stock"),
        link: "/manage-stocks",
        icon: "stack-3",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Stock Adjustment"),
        link: "/stock-adjustment",
        icon: "stairs-up",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Stock Transfer"),
        link: "/stock-transfer",
        icon: "stack-pop",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: translate("Inventory Logs"),
    submenuOpen: true,
    submenuHdr: "Inventory Logs",
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: translate("Stock Transfer"),
        link: "/inventory-logs/stock-transfer",
        icon: "stack-pop", // or "history", "arrows-shuffle" — your icon set
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  // {
  //   label: translate("Sales"),
  //   submenuOpen: true,
  //   submenuHdr: "Sales",
  //   submenu: true,
  //   showSubRoute: true,
  //   submenuItems: [
  //     {
  //       label: translate("Sales"),
  //       icon: "layout-grid",
  //       showSubRoute: true,
  //       submenu: true,
  //       submenuItems: [
  //         {
  //           label: translate("Online Orders"),
  //           link: "/online-orders",
  //           showSubRoute: true,
  //         },
  //         {
  //           label: translate("POS Orders"),
  //           link: route.posorder,
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     // {
  //     //   label: translate("Invoices"),
  //     //   link: route.invoice,
  //     //   icon: "file-invoice",
  //     //   showSubRoute: true,
  //     //   submenu: true,
  //     // },
  //     // {
  //     //   label: translate("Sales Return"),
  //     //   link: "/sales-returns",
  //     //   icon: "receipt-refund",
  //     //   showSubRoute: false,
  //     //   submenu: false,
  //     // },
  //     // {
  //     //  label: translate("Quotation"),
  //     //   link: "/quotation-list",
  //     //   icon: "files",
  //     //   showSubRoute: false,
  //     //   submenu: false,
  //     // },
  //     // {
  //     //  label: translate("POS"),
  //     //   icon: "device-laptop",
  //     //   showSubRoute: false,
  //     //   submenu: true,
  //     //   submenuItems: [
  //     //     { label: "POS 1", link: "/pos", showSubRoute: false },
  //     //     { label: "POS 2", link: "/pos-2", showSubRoute: false },
  //     //     { label: "POS 3", link: "/pos-3", showSubRoute: false },
  //     //     { label: "POS 4", link: "/pos-4", showSubRoute: false },
  //     //     { label: "POS 5", link: "/pos-5", showSubRoute: false },
  //     //   ],
  //     // },
  //   ],
  // },
  // {
  //  label: translate("Promo"),
  //   submenuOpen: true,
  //   submenuHdr: "Promo",
  //   showSubRoute: false,
  //   submenuItems: [
  //     {
  //      label: translate("Coupons"),
  //       link: "/coupons",
  //       icon: "ticket",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Gift Cards"),
  //       link: route.GiftCard,
  //       icon: "cards",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Discount"),
  //       icon: "file-percent",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         {
  //          label: translate("Discount Plan"),
  //           link: route.discountPlan,
  //           showSubRoute: false,
  //         },
  //         {label: translate("Discount"), link: route.discount, showSubRoute: false },
  //       ],
  //     },
  //   ],
  // },
  // {
  //  label: translate("Purchases"),
  //   submenuOpen: true,
  //   submenuHdr: "Purchases",
  //   showSubRoute: false,
  //   submenuItems: [
  //     {
  //      label: translate("Purchases"),
  //       link: "/purchase-list",
  //       icon: "shopping-bag",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Purchase Order"),
  //       link: "/purchase-order-report",
  //       icon: "file-unknown",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Purchase Return"),
  //       link: "/purchase-returns",
  //       icon: "file-upload",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //   ],
  // },

  // {
  //  label: translate("Finance & Accounts"),
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Finance & Accounts",
  //   submenuItems: [
  //     {
  //      label: translate("Expenses"),
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "file-stack",
  //       submenuItems: [
  //         {label: translate("Expenses"), link: "/expense-list", showSubRoute: false },
  //         {
  //           label: "Expense Category",
  //           link: "/expense-category",
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //      label: translate("Income"),
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "file-pencil",
  //       submenuItems: [
  //         {label: translate("Income"), link: "/income", showSubRoute: false },
  //         {
  //           label: "Income Category",
  //           link: "/income-category",
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //      label: translate("Bank Accounts"),
  //       link: route.accountlist,
  //       icon: "building-bank",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Money Transfer"),
  //       link: "/money-transfer",
  //       icon: "moneybag",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Balance Sheet"),
  //       link: "/balance-sheet",
  //       icon: "report-money",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Trial Balance"),
  //       link: "/trial-balance",
  //       icon: "alert-circle",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Cash Flow"),
  //       link: "/cash-flow",
  //       icon: "zoom-money",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("Account Statement"),
  //       link: "/account-statement",
  //       icon: "file-infinity",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //   ],
  // },

  {
    label: translate("People"),
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "People",

    submenuItems: [
      {
        label: translate("Customers"),
        link: route.customers,
        icon: "users-group",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Billers"),
        link: "/billers",
        icon: "user-up",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Suppliers"),
        link: "/suppliers",
        icon: "user-dollar",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Warehouses"),
        link: "/warehouse",
        icon: "archive",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: translate("Stores"),
        link: "/store-list",
        icon: "home-bolt",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  // {
  //  label: translate("HRM"),
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "HRM",
  //   submenuItems: [
  //     {
  //      label: translate("Employees"),
  //       link: "/employees-grid",
  //       icon: "user",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Departments"),
  //       link: "/department-grid",
  //       icon: "compass",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Designations"),
  //       link: "/designation",
  //       icon: "git-merge",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Shifts"),
  //       link: "/shift",
  //       icon: "arrows-shuffle",
  //       showSubRoute: false,
  //     },

  //     {
  //      label: translate("Attendance"),
  //       link: "#",
  //       icon: "user-cog",
  //       showSubRoute: false,
  //       submenu: true,

  //       submenuItems: [
  //         {label: translate("Employee"), link: "/attendance-employee" },
  //         {label: translate("Admin"), link: "/attendance-admin" },
  //       ],
  //     },
  //     {
  //      label: translate("Leaves"),
  //       link: "#",
  //       icon: "calendar",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         { label: "Employee Leaves", link: "/leaves-employee" },
  //         { label: "Admin Leaves", link: "/leaves-admin" },
  //         { label: "Leave Types", link: "/leave-types" },
  //       ],
  //     },
  //     {
  //      label: translate("Holidays"),
  //       link: "/holidays",
  //       icon: "calendar-share",
  //       showSubRoute: false,
  //     },

  //     {
  //      label: translate("Payroll"),
  //       link: "#",
  //       icon: "file-dollar",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         { label: "Employee Salary", link: route.payrollList },
  //         { label: "Payslip", link: "/payslip" },
  //       ],
  //     },
  //   ],
  // },
  // {
  //  label: translate("Reports"),
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Reports",
  //   submenuItems: [
  //     {
  //      label: translate("Sales Report"),
  //       icon: "chart-bar",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         {label: translate("Sales Report"), link: "/sales-report" },
  //         { label: "Best Seller", link: "/best-seller" },
  //       ],
  //     },
  //     {
  //      label: translate("Purchase Report"),
  //       link: "/purchase-report",
  //       icon: "chart-pie-2",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Inventory Report"),
  //       icon: "triangle-inverted",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         {label: translate("Inventory Report"), link: "/inventory-report" },
  //         { label: "Stock History", link: "/stock-history" },
  //         { label: "Sold Stock", link: "/sold-stock" },
  //       ],
  //     },
  //     {
  //      label: translate("Invoice Report"),
  //       link: route.invoicereportnew,
  //       icon: "businessplan",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Supplier Report"),
  //       icon: "user-star",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         {label: translate("Supplier Report"), link: "/supplier-report" },
  //         { label: "Supplier Due Report", link: "/supplier-due-report" },
  //       ],
  //     },
  //     {
  //      label: translate("Customer Report"),

  //       icon: "report",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         {label: translate("Customer Report"), link: "/customer-report" },
  //         { label: "Customer Due Report", link: "/customer-due-report" },
  //       ],
  //     },
  //     {
  //      label: translate("Product Report"),
  //       icon: "report-analytics",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         {label: translate("Product Report"), link: "/product-report" },
  //         { label: "Product Expiry Report", link: "/product-expiry-report" },
  //         {
  //           label: "Product Quantity Alert",
  //           link: route.productquantityreport,
  //         },
  //       ],
  //     },
  //     {
  //      label: translate("Expense Report"),
  //       link: "/expense-report",
  //       icon: "file-vector",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Income Report"),
  //       link: "/income-report",
  //       icon: "chart-ppf",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Tax Report"),
  //       link: "/tax-report",
  //       icon: "chart-dots-2",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Profit & Loss"),
  //       link: "/profit-loss-report",
  //       icon: "chart-donut",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Annual Report"),
  //       link: "/annual-report",
  //       icon: "report-search",
  //       showSubRoute: false,
  //     },
  //   ],
  // },

  // {
  //  label: translate("Content (CMS) "),
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Content (CMS)",
  //   submenuItems: [
  //     {
  //      label: translate("Pages"),
  //       icon: "page-break",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [{label: translate("Pages"), link: "/pages" }],
  //     },
  //     {
  //      label: translate("Blog"),
  //       icon: "wallpaper",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         { label: "All Blog", link: all_routes.allBlogs },
  //         { label: "Blog Tags", link: all_routes.blogTag },
  //         { label: "Categories", link: all_routes.blogCategories },
  //         { label: "Blog Comments", link: all_routes.blogComments },
  //       ],
  //     },
  //     {
  //      label: translate("Location"),
  //       icon: "map-pin",
  //       showSubRoute: false,
  //       submenu: true,
  //       submenuItems: [
  //         { label: "Countries", link: all_routes.countries },
  //         { label: "States", link: all_routes.states },
  //         { label: "Cities", link: all_routes.cities },
  //       ],
  //     },
  //     {
  //      label: translate("Testimonials"),
  //       icon: "star",
  //       link: all_routes.testimonial,
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //      label: translate("FAQ"),
  //       icon: "help-circle",
  //       link: all_routes.faq,
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //   ],
  // },
  // {
  //  label: translate("User Management"),
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "User Management",
  //   submenuItems: [
  //     {
  //       label: "Users",
  //       link: "/users",
  //       icon: "shield-up",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Roles & Permissions"),
  //       link: "/roles-permissions",
  //       icon: "jump-rope",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Roles & Permissions"),
  //       link: "/delete-account",
  //       icon: "trash-x",
  //       showSubRoute: false,
  //     },
  //   ],
  // },
  // {
  //  label: translate("Pages"),
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Pages",
  //   submenuItems: [
  //     {
  //      label: translate("Profile"),
  //       link: "/profile",
  //       icon: "user-circle",
  //       showSubRoute: false,
  //     },
  //     {
  //      label: translate("Authentication"),
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "shield",
  //       submenuItems: [
  //         {
  //          label: translate("Login"),
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {label: translate("Cover"), link: "/signin", showSubRoute: false },
  //             {label: translate("Illustration"), link: "/signin-2", showSubRoute: false },
  //             {label: translate("Basic"), link: "/signin-3", showSubRoute: false },
  //           ],
  //         },
  //         {
  //          label: translate("Register"),
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {label: translate("Cover"), link: "/register", showSubRoute: false },
  //             {
  //              label: translate("Illustration"),
  //               link: "/register-2",
  //               showSubRoute: false,
  //             },
  //             {label: translate("Basic"), link: "/register-3", showSubRoute: false },
  //           ],
  //         },
  //         {
  //           label: "Forgot Password",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {label: translate("Cover"), link: "/forgot-password", showSubRoute: false },
  //             {
  //              label: translate("Illustration"),
  //               link: "/forgot-password-2",
  //               showSubRoute: false,
  //             },
  //             {
  //              label: translate("Basic"),
  //               link: "/forgot-password-3",
  //               showSubRoute: false,
  //             },
  //           ],
  //         },
  //         {
  //           label: "Reset Password",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {label: translate("Cover"), link: "/reset-password", showSubRoute: false },
  //             {
  //              label: translate("Illustration"),
  //               link: "/reset-password-2",
  //               showSubRoute: false,
  //             },
  //             {
  //              label: translate("Basic"),
  //               link: "/reset-password-3",
  //               showSubRoute: false,
  //             },
  //           ],
  //         },
  //         {
  //          label: translate("Email Verification"),
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {
  //              label: translate("Cover"),
  //               link: "/email-verification",
  //               showSubRoute: false,
  //             },
  //             {
  //              label: translate("Illustration"),
  //               link: "/email-verification-2",
  //               showSubRoute: false,
  //             },
  //             {
  //              label: translate("Basic"),
  //               link: "/email-verification-3",
  //               showSubRoute: false,
  //             },
  //           ],
  //         },
  //         {
  //           label: "2 Step Verification",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {
  //              label: translate("Cover"),
  //               link: "/two-step-verification",
  //               showSubRoute: false,
  //             },
  //             {
  //              label: translate("Illustration"),
  //               link: "/two-step-verification-2",
  //               showSubRoute: false,
  //             },
  //             {
  //              label: translate("Basic"),
  //               link: "/two-step-verification-3",
  //               showSubRoute: false,
  //             },
  //           ],
  //         },
  //         { label: "Lock Screen", link: "/lock-screen", showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Error Pages",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "file-x",
  //       submenuItems: [
  //         { label: "404 Error", link: "/error-404", showSubRoute: false },
  //         { label: "500 Error", link: "/error-500", showSubRoute: false },
  //       ],
  //     },
  //     // {
  //     //   label: "Places",
  //     //   submenu: true,
  //     //   showSubRoute: false,
  //     //   icon: <Icon.Map />,
  //     //   submenuItems: [
  //     //     { label: "Countries", link: "countries",showSubRoute: false },
  //     //     { label: "States", link: "states",showSubRoute: false }
  //     //   ]
  //     // },
  //     {
  //       label: "Blank Page",
  //       link: "/blank-page",
  //       icon: "file",
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Pricing",
  //       link: route.pricing,
  //       icon: "currency-dollar",
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Coming Soon",
  //       link: "/coming-soon",
  //       icon: "send",
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Under Maintenance",
  //       link: "/under-maintenance",
  //       icon: "alert-triangle",
  //       showSubRoute: false,
  //     },
  //   ],
  // },

  // {
  //  label: translate("Settings"),
  //   submenu: true,
  //   showSubRoute: false,
  //   submenuHdr: "Settings",
  //   submenuItems: [
  //     {
  //      label: translate("General Settings"),
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "settings",
  //       submenuItems: [
  //         {label: translate("Profile"), link: "/general-settings" },
  //         { label: "Security", link: "/security-settings" },
  //         { label: "Notifications", link: "/notification" },
  //         { label: "Connected Apps", link: "/connected-apps" },
  //       ],
  //     },
  //     {
  //      label: translate("Website Settings"),
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "world",
  //       submenuItems: [
  //         {
  //          label: translate("System Settings"),
  //           link: "/system-settings",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Company Settings",
  //           link: "/company-settings",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Localization",
  //           link: "/localization-settings",
  //           showSubRoute: false,
  //         },
  //         { label: "Prefixes", link: "/prefixes", showSubRoute: false },
  //         { label: "Preference", link: "/preference", showSubRoute: false },
  //         { label: "Appearance", link: "/appearance", showSubRoute: false },
  //         {
  //           label: "Social Authentication",
  //           link: "/social-authentication",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Language",
  //           link: "/language-settings",
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //      label: translate("App Settings"),
  //       submenu: true,

  //       showSubRoute: false,
  //       icon: "device-mobile",
  //       submenuItems: [
  //         {
  //          label: translate("Invoice"),
  //           link: "/invoice-settings",
  //           showSubRoute: false,
  //           submenu: true,
  //           submenuItems: [
  //             {label: translate("Invoice Settings"), link: "/invoice-settings" },
  //             {label: translate("Invoice Template"), link: "/invoice-template" },
  //           ],
  //         },
  //         {label: translate("Printer"), link: "/printer-settings", showSubRoute: false },
  //         {label: translate("POS"), link: "/pos-settings", showSubRoute: false },
  //         {
  //          label: translate("Custom Fields"),
  //           link: "/custom-fields",
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //      label: translate("System Settings"),
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "device-desktop",
  //       submenuItems: [
  //         {
  //           label: translate("Email"),
  //           link: "/email-settings",
  //           showSubRoute: false,
  //           submenu: true,
  //           submenuItems: [
  //             { label: "Email Settings", link: "/email-settings" },
  //             { label: "Email Template", link: "/email-template" },
  //           ],
  //         },
  //         {
  //          label: translate("SMS Gateways"),
  //           link: "/sms-gateway",
  //           showSubRoute: false,
  //           submenu: true,
  //           submenuItems: [
  //             {label: translate("SMS Settings"), link: "/sms-settings" },
  //             {label: translate("SMS Template"), link: route.smstemplate },
  //           ],
  //         },
  //         {label: translate("OTP"), link: "/otp-settings", showSubRoute: false },
  //         {
  //          label: translate("GDPR Cookies"),
  //           link: "/gdpr-settings",
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //      label: translate("Financial Settings"),
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "settings-dollar",
  //       submenuItems: [
  //         {
  //          label: translate("Payment Gateway"),
  //           link: "/payment-gateway-settings",
  //           showSubRoute: false,
  //         },
  //         {
  //          label: translate("Bank Accounts"),
  //           link: "/bank-settings-grid",
  //           showSubRoute: false,
  //         },
  //         { label: "Tax Rates", link: "/tax-rates", showSubRoute: false },
  //         {
  //           label: "Currencies",
  //           link: "/currency-settings",
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //      label: translate("Other Settings"),
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "settings-2",
  //       submenuItems: [
  //         { label: "Storage", link: "/storage-settings", showSubRoute: false },
  //         {
  //           label: "Ban IP Address",
  //           link: "/ban-ip-address",
  //           showSubRoute: false,
  //         },
  //       ],
  //     },
  //     {
  //      label: translate("Logout"),
  //       link: "/signin",
  //       icon: "logout",
  //       showSubRoute: false,
  //     },
  //   ],
  // },

  // {
  //   label: "UI Interface",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "UI Interface",
  //   submenuItems: [
  //     {
  //       label: "Base UI",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "vector-bezier",
  //       submenuItems: [
  //         { label: "Alerts", link: "/ui-alerts", showSubRoute: false },
  //         { label: "Accordion", link: "/ui-accordion", showSubRoute: false },
  //         { label: "Avatar", link: "/ui-avatar", showSubRoute: false },
  //         { label: "Badges", link: "/ui-badges", showSubRoute: false },
  //         { label: "Border", link: "/ui-borders", showSubRoute: false },
  //         { label: "Buttons", link: "/ui-buttons", showSubRoute: false },
  //         {
  //           label: "Button Group",
  //           link: "/ui-buttons-group",
  //           showSubRoute: false,
  //         },
  //         { label: "Breadcrumb", link: "/ui-breadcrumb", showSubRoute: false },
  //         { label: "Card", link: "/ui-cards", showSubRoute: false },
  //         { label: "Carousel", link: "/ui-carousel", showSubRoute: false },
  //         { label: "Colors", link: "/ui-colors", showSubRoute: false },
  //         { label: "Dropdowns", link: "/ui-dropdowns", showSubRoute: false },
  //         { label: "Grid", link: "/ui-grid", showSubRoute: false },
  //         { label: "Images", link: "/ui-images", showSubRoute: false },
  //         { label: "Lightbox", link: "/ui-lightbox", showSubRoute: false },
  //         { label: "Media", link: "/ui-media", showSubRoute: false },
  //         { label: "Modals", link: "/ui-modals", showSubRoute: false },
  //         { label: "Offcanvas", link: "/ui-offcanvas", showSubRoute: false },
  //         { label: "Pagination", link: "/ui-pagination", showSubRoute: false },
  //         { label: "Popovers", link: "/ui-popovers", showSubRoute: false },
  //         { label: "Progress", link: "/ui-progress", showSubRoute: false },
  //         {
  //           label: "Placeholders",
  //           link: "/ui-placeholders",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Range Slider",
  //           link: "/ui-rangeslider",
  //           showSubRoute: false,
  //         },
  //         { label: "Spinner", link: "/ui-spinner", showSubRoute: false },
  //         {
  //           label: "Sweet Alerts",
  //           link: "/ui-sweetalerts",
  //           showSubRoute: false,
  //         },
  //         { label: "Tabs", link: "/ui-nav-tabs", showSubRoute: false },
  //         { label: "Toasts", link: "/ui-toasts", showSubRoute: false },
  //         { label: "Tooltips", link: "/ui-tooltips", showSubRoute: false },
  //         { label: "Typography", link: "/ui-typography", showSubRoute: false },
  //         { label: "Video", link: "/ui-video", showSubRoute: false },
  //         { label: "Sortable", link: "/sortable", showSubRoute: false },
  //         { label: "SwiperJs", link: "/swiper-js", showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Advanced UI",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "stack-forward",
  //       submenuItems: [
  //         { label: "Ribbon", link: "/ui-ribbon", showSubRoute: false },
  //         { label: "Clipboard", link: "/ui-clipboard", showSubRoute: false },
  //         { label: "Drag & Drop", link: "/ui-drag-drop", showSubRoute: false },
  //         {
  //           label: "Range Slider",
  //           link: "/ui-rangeslider",
  //           showSubRoute: false,
  //         },
  //         { label: "Rating", link: "/ui-rating", showSubRoute: false },
  //         {
  //           label: "Text Editor",
  //           link: "/ui-text-editor",
  //           showSubRoute: false,
  //         },
  //         { label: "Counter", link: "/ui-counter", showSubRoute: false },
  //         { label: "Scrollbar", link: "/ui-scrollbar", showSubRoute: false },
  //         { label: "Sticky Note", link: "/ui-stickynote", showSubRoute: false },
  //         { label: "Timeline", link: "/ui-timeline", showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Charts",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "chart-infographic",
  //       submenuItems: [
  //         { label: "Apex Charts", link: "/chart-apex", showSubRoute: false },
  //         { label: "Chart Js", link: "/chart-js", showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Icons",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "icons",
  //       submenuItems: [
  //         {
  //           label: "Fontawesome Icons",
  //           link: "/icon-fontawesome",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Remix Icon",
  //           link: "/remix-icon",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Bootstrap Icon",
  //           link: "/bootstrap-icon",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Tabler Icon",
  //           link: "/tabler-icon",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Feather Icons",
  //           link: "/icon-feather",
  //           showSubRoute: false,
  //         },
  //         { label: "Ionic Icons", link: "/icon-ionic", showSubRoute: false },
  //         {
  //           label: "Material Icons",
  //           link: "/icon-material",
  //           showSubRoute: false,
  //         },
  //         { label: "Pe7 Icons", link: "/icon-pe7", showSubRoute: false },
  //         {
  //           label: "Simpleline Icons",
  //           link: "/icon-simpleline",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Themify Icons",
  //           link: "/icon-themify",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Weather Icons",
  //           link: "/icon-weather",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Typicon Icons",
  //           link: "/icon-typicon",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Tabler Icons",
  //           link: "/icon-tabler",
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Bootstrap Icons",
  //           link: "/icon-bootstrap",
  //           showSubRoute: false,
  //         },
  //         { label: "Flag Icons", link: "/icon-flag", showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Forms",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "input-search",
  //       submenuItems: [
  //         {
  //           label: "Form Elements",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {
  //               label: "Basic Inputs",
  //               link: "/form-basic-inputs",
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Checkbox & Radios",
  //               link: "/form-checkbox-radios",
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Input Groups",
  //               link: "/form-input-groups",
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Grid & Gutters",
  //               link: "/form-grid-gutters",
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Form Select",
  //               link: "/form-select",
  //               showSubRoute: false,
  //             },
  //             { label: "Input Masks", link: "/form-mask", showSubRoute: false },
  //             {
  //               label: "File Uploads",
  //               link: "/form-fileupload",
  //               showSubRoute: false,
  //             },
  //           ],
  //         },
  //         {
  //           label: "Layouts",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Horizontal Form", link: "/form-horizontal" },
  //             { label: "Vertical Form", link: "/form-vertical" },
  //             { label: "Floating Labels", link: "/form-floating-labels" },
  //           ],
  //         },
  //         { label: "Form Validation", link: "/form-validation" },
  //         { label: "Select", link: "/form-select2" },
  //         { label: "Form Wizard", link: "/form-wizard" },
  //         { label: "Form Picker", link: "/form-picker" },
  //       ],
  //     },
  //     {
  //       label: "Tables",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "table",
  //       submenuItems: [
  //         { label: "Basic Tables", link: "/tables-basic" },
  //         { label: "Data Table", link: "/data-tables" },
  //       ],
  //     },
  //     {
  //       label: "Map",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "map-pin-pin",
  //       submenuItems: [{ label: "Leaflet", link: "/leaflet" }],
  //     },
  //   ],
  // },
  // {
  //   label: "Help",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Help",
  //   submenuItems: [
  //     {
  //       label: "Documentation",
  //       link: "#",
  //       icon: "file-text",
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Changelog v2.0.7",
  //       link: "#",
  //       icon: "exchange",
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Multi Level",
  //       showSubRoute: false,
  //       submenu: true,
  //       icon: "menu-2",
  //       submenuItems: [
  //         { label: "Level 1.1", link: "#", showSubRoute: false },
  //         {
  //           label: "Level 1.2",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Level 2.1", link: "#", showSubRoute: false },
  //             {
  //               label: "Level 2.2",
  //               submenu: true,
  //               showSubRoute: false,
  //               submenuItems: [
  //                 { label: "Level 3.1", link: "#", showSubRoute: false },
  //                 { label: "Level 3.2", link: "#", showSubRoute: false },
  //               ],
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },
];
